<template>
  <div class="main-body">
    <div class="header">政府列表</div>
    <div class="out">

      <div class="search2">

        <div style="float: left;">
          <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">添加</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th" border>

        <el-table-column prop="name" label="公司/政府名称" width="150" fixed></el-table-column>
        <el-table-column prop="contacts" label="联系人" width="100"></el-table-column>
        <el-table-column prop="tel" label="联系电话" width="150"></el-table-column>

        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0">默认</div>
            <div v-if="scope.row.status == 1">正常</div>
            <div v-if="scope.row.status == 2" style="color: red;">被禁用</div>
          </template>
        </el-table-column>

        <el-table-column prop="province" label="省份" width="100"></el-table-column>
        <el-table-column prop="city" label="城市" width="100"></el-table-column>
        <el-table-column prop="district" label="地区" width="100"></el-table-column>
        <el-table-column prop="address" label="详细地址" width="280"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180">
          <template slot-scope="scope">
            <p>{{ scope.row.createTime | timefilters }}</p>
          </template>
        </el-table-column>

        <el-table-column prop="listStaffDTO" label="管理员" width="180">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listStaffDTO" :key="index">
              <div>{{item.loginName}}</div>
            </div>
          </template>
        </el-table-column>



        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" size="mini" @click="handlePassword(scope.$index, scope.row)">修改密码</el-button>
            <el-button type="text" size="mini" @click="handleXDu(scope.$index, scope.row)">小度</el-button>

          </template>
        </el-table-column>

      </el-table>

      <div class="page" >
        <div style="float: left;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="pageSize"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-bind:roleValue="roleValue"
         v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-bind:roleValue="roleValue"
          v-on:getList="getList"></Edit>

    <el-dialog title="密码修改" :visible.sync="batchDialog" class="dialog" width='400px' center top='30vh'
               :close-on-click-modal='false'>
      <el-input v-model="password" placeholder="请输入登录密码" maxlength="20" minlength="6"
                show-password></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialog=false">取 消</el-button>
        <el-button type="primary" @click="editPassword">提交</el-button>
      </div>
    </el-dialog>

    <EditXDu ref="myEditXDu" v-show="showModalEditXDu" v-on:closeEditXDu="showModalEditXDu=false" v-on:getList="getList"></EditXDu>


  </div>
</template>

<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import Edit from "./Edit";
import Add from "./Add";

import EditXDu from "./EditXDu";

export default {
  name: "Page",
  components: {Add, Edit,EditXDu},

  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month =
            d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times = d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data() {
    return {
      loading: false,

      showModalAdd: false,
      showModalEdit: false,
      showModalDeal: false,
      showModalEditSon: false,
      showModalEditXDu:false,

      batchDialog: false,
      governmentCode:'',
      password:'',

      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      roleValue: [],

      th: 0,

      imgUrl: this.$imgUrl,

    }
  },

  created() {
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  methods: {

    init() {

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Role/ListGovRole",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              console.log(response.data.data)
              var roleValue = response.data.data;
              roleValue = this.remove(roleValue, '商家')
              roleValue = this.remove(roleValue, '政府管理员')
              roleValue = this.remove(roleValue, '系统管理员')
              roleValue = this.remove(roleValue, '超级管理员')
              this.roleValue = roleValue
            } else if (response.data.error == 1) {
              this.$message(response.data.message);
            } else {
              console.log(response.data.message);
            }

          }
      )


    },
    remove(array, name) {
      for (var i = 0; i < array.length; i++) {
        if (array[i].name == name) {
          array.splice(i, 1);
          return array
        }

      }
    },


    toggleModalAdd: function () {
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },


    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },


    handlePassword(index, rows) {
      this.batchDialog = true;
      this.governmentCode = rows.governmentCode
    },
    editPassword() {

      if (this.password.length < 6) {
        this.$message('密码至少为六位')
        return;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + 'Government/EditPassword',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          governmentCode: this.governmentCode,
          password: this.password,
        }
      }).then((response) => {
        //console.log(response);
        if (response.data.error == 0) {
          this.$message('修改成功');
          this.batchDialog = false
        } else if (response.data.error == 1) {
          this.$message(response.data.message);
        } else {
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Government/Page",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
        }
      }).then((response) => {
        //console.log(response);
        if (response.data.error == 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        } else {
          console.log(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },


    handleXDu(index,row){
      this.$refs.myEditXDu.init(row);
      this.showModalEditXDu = !this.showModalEditXDu;
    },


  }
}
</script>

